import React, { useState } from 'react';

function Billinvoice() {

  


  return (
             <div className="reportmap_1s reportmap_2s">
                <div className="reportpaid">Paid Invoices</div>
                <div className="reportoutstand">Outstanding Invoices</div>
              </div>          
  );
}

export default Billinvoice;
